import { uuid } from '../utils';
import {
  COMICS
} from './categories';

export default {
  id: uuid(),
  priority: 2,
  name: 'Grandma 13',
  thumbnail: './Grandma/a5_jamThumb.jpg',
  categories: [ COMICS ],
  content: [
    './Grandma/a5-jam1.jpg',
    './Grandma/A5-jam2.jpg',
    './Grandma/A5-jam3.jpg',
    './Grandma/A5-jam4.jpg'
  ]
};




// WEBPACK FOOTER //
// ./src/projects/grandma.js